import { configureStore } from "@reduxjs/toolkit";
import portalApi from "../features/api/apiSlice";
import authReducer from "../features/Auth/authSlice";

export const store = configureStore({
  reducer: {
    [portalApi.reducerPath]: portalApi.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(portalApi.middleware),
});
